import axiosConfig from './axiosConfig';

export const versionAPI = {
    get: async () => {
        // Add cache-busting timestamp to force fresh data
        const timestamp = Date.now();
        const response = await axiosConfig.get(`/api/version/?t=${timestamp}`);
        return response.data;
    }
};